import { render, staticRenderFns } from "./DetailsFertAssist.vue?vue&type=template&id=ab9e8cf0&"
import script from "./DetailsFertAssist.vue?vue&type=script&lang=js&"
export * from "./DetailsFertAssist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports